
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const PurpleQuestionIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.25-1.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.252a1.5 1.5 0 0 1-.248.823l-.376.563c-.182.273-.477.565-.752.876l-.275.306a.75.75 0 0 1-1.056 0l-.275-.306c-.275-.31-.57-.603-.752-.876l-.376-.563A1.5 1.5 0 0 1 9 10.752V10.5a.75.75 0 0 1 .75-.75Zm1.5 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" 
      clipRule="evenodd" 
    />
  </svg>
);

export default PurpleQuestionIcon;
